'use client'

import { useEffect } from 'react'
import { usePostHog } from 'posthog-js/react'
import { useAuth } from '@/components/auth/auth-context'

export function PostHogIdentify() {
  const posthog = usePostHog()
  const { user } = useAuth()

  useEffect(() => {
    if (!posthog) return

    if (user?.email) {
      posthog.identify(user.email, {
        email: user.email,
        first_name: user.firstName,
        company_id: user.companyId,
      })
    } else {
      posthog.reset()
    }
  }, [posthog, user?.email, user?.firstName, user?.companyId])

  return null
}
